export class EnableRestoreAccountMetricsConfigResponse {
    'restoreAccountConfig';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountConfig",
            "baseName": "restoreAccountConfig",
            "type": "RestoreAccountMetricsConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EnableRestoreAccountMetricsConfigResponse.attributeTypeMap;
    }
    constructor() {
    }
}
